import React from 'react'
import axios from "axios";

import en from '../../../locales/en/translation.json';
import fr from '../../../locales/fr/translation.json';

import about_first from '../../../assets/images/about_first.jpg';

import isignup from '../../../assets/logos/jeminscris.svg';
import job from '../../../assets/logos/seeJob.svg';
import isignup_en from '../../../assets/logos/en/isignup.svg';
import job_en from '../../../assets/logos/en/seeJob_en.svg';

import bulle from '../../../assets/images/icon/bulle.png';
import triple from '../../../assets/images/icon/triple.png';
import video from '../../../assets/images/icon/video.png';

export default class About extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: 'en',
            trad: en,
            equipe: null,
            actualite: null,
        }
    }

    componentDidMount() {
        if (JSON.parse(localStorage.getItem("user"))) {
            this.setState({
                user: JSON.parse(localStorage.getItem("user")),
            }, () => {
                let lang = this.state.user.user.language;
                if (lang === "fr") {
                    this.setState({lang: "fr", trad: fr});
                }
            });
        }

        let url_equipe = import.meta.env.VITE_BACKEND_URL + '/equipe/get';
        let url_actu = import.meta.env.VITE_BACKEND_URL + '/actualite/get3';
        axios.get(url_equipe).then((res) => {
            this.setState({equipe: res.data});
        }).catch((error) => {
            console.log(error);
        });
        axios.get(url_actu).then((res) => {
            this.setState({actualite: res.data});
        }).catch((error) => {
            console.log(error);
        });

    }

    render() {
        const {trad} = this.state;
        const {lang} = this.state;
        return (
            <div className="about_page">
                <div className="header_about">
                    <h1>{trad.propoTitle}</h1>
                    <p>{trad.propoBaseligne}</p>
                </div>
                <div className="conviction">
                    <div className="left">
                        <h2>{trad.propoConvictionTitle}</h2>
                        <p>{trad.propoConvictionLine1}</p>
                        <p>{trad.propoConvictionLine2}</p>
                        <p>{trad.propoConvictionLine3}</p>
                        <div className="block_btn">
                            <a className="inscription" href="/inscription">
                                <img src={lang == "en" ? isignup_en : isignup} alt=""/>
                            </a>
                        </div>
                    </div>
                    <div className="right">
                        <img src={about_first} alt=""/>
                    </div>
                </div>
                <div className="vision">
                    <div className="overlay">
                        <h2>{trad.valeurTitle}</h2>
                        <p>{trad.valeur1}</p>
                        <div className="block_icon">
                            <div className="icon">
                                <img src={video} alt=""/>
                                <p>{trad.valeurCol1}</p>
                            </div>
                            <div className="icon">
                                <img src={bulle} alt=""/>
                                <p>{trad.valeurCol2}</p>

                            </div>
                            <div className="icon">
                                <img src={triple} alt=""/>
                                <p>{trad.valeurCol3}</p>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="equipe">
                    <h2>{trad.equipeTitle}</h2>
                    <div className="block_equipe">
                        {this.state.equipe && this.state.equipe.map((item, index) => {
                            return (
                                <div key={index} className="membre">
                                    <div className="center_img">
                                        <img src={import.meta.env.VITE_BACKEND_URL_IMG + "/uploads/" + item.image}
                                             alt=""/>
                                    </div>
                                    <p className="name">{item.prenom} {item.nom}</p>
                                    <p className="fonction">{item.fonction}</p>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className="block_liste">
                    <p>{trad.artisteTitle}</p>
                    <div className="liste">
                        <div className="item">
                            <div className="item_block">
                                <p>{trad.artiste1}</p>
                            </div>
                            <p>{trad.pour1}</p>
                            <div className="item_block">
                                <p>{trad.auditeur1}</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="item_block">
                                <p>{trad.artiste2}</p>
                            </div>
                            <p>{trad.pour2}</p>
                            <div className="item_block">
                                <p>{trad.auditeur2}</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="item_block">
                                <p>{trad.artiste3}</p>
                            </div>
                            <p>{trad.pour3}</p>
                            <div className="item_block">
                                <p>{trad.auditeur3}</p>
                            </div>
                        </div>
                    </div>
                    <p>{trad.auditeurTitle}</p>
                </div>
                <div className="last_actualite">
                    <div className="header_actu">
                        <h2>{trad.actualiteTitle}</h2>
                        <p>{trad.actualite1}</p>
                    </div>
                    <div className="list_actu">
                        {
                            this.state.actualite && this.state.actualite.map((actu, index) => (
                                <a href={`/actualite/${actu.slug}`} target="_blank" key={index}>
                                    <div className="actualite">
                                        <div className="actualite-img">
                                            <img src={import.meta.env.VITE_BACKEND_URL_IMG + "/uploads/" + actu.image}
                                                 alt={actu.titre}/>
                                        </div>
                                        <div className="actualite-text">
                                            <h2>{actu.titre}</h2>
                                            <p className="description">{actu.description}</p>
                                            <p className="qui_date">Par Anne-Louise GAYMARD - 14 mars 2023</p>
                                        </div>
                                    </div>
                                </a>
                            ))
                        }
                    </div>
                </div>
                <div className="rejoindre">
                    <h2>{trad.rejoindreTitle}</h2>
                    <p>{trad.rejoindre1}</p>
                    <div className="block_btn">
                        <a className="inscription" href="/emplois">
                            <img src={lang == "en" ? job_en : job} alt=""/>
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}
